import React, { useEffect, useState } from 'react';
import styles from './UsersTable.module.css';
import downArrow from '../../../assets/Imagess/downarrow.svg';
import upArrow from '../../../assets/Imagess/Vector.svg';
import checkedicon from '../../../assets/Imagess/tableiconheadgreen.svg';
import CheckBox from '../../Atoms/Inputs/CheckBox';
import deleteIcon from '../../../assets/Imagess/greenDelete.svg';
import editIcon from '../../../assets/Imagess/greenEdit.svg';
import assignIcon from '../../../assets/Imagess/greenReassign.svg';
import ProfilePsswordIcon from '../../../assets/Imagess/ProfilePsswordIcon.svg';
import TablePagination from '../Pagination/TablePagination';
import Loader from '../Loader/Loader';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import MoreButton from '../Custom/MoreButton';
import PopOver from '../Custom/PopOver/PopOver';

const UsersTable = ({
  tableHeader,
  data,
  setDeleteMode,
  selected,
  setSelected,
  page,
  setPage,
  setSelectedUser,
  setPageSize,
  pageSize,
  isUsersLoading,
  setIsModalOpen,
  setModalMode,
  setEachUser,
  setAssignRole,
  order,
  setOrder,
  refetchUsers,
  pagesDataCount = 0,
  setViewModal,
  setResetPasword,
}) => {
  const [checked, setChecked] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const itemsPerPage = data?.pageSize;
  const totalItems = data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const handleOnClick = (e, id) => {
    e.preventDefault();
    window.location.href = `/home/applicants/${id}`;
  };
  const handleCheckboxClick = (e, itemid) => {
    setChecked(selected?.includes(itemid));

    e.stopPropagation();
  };

  const toggleCheckUser = (itemId) => {
    if (checked) {
      setSelected((prevSelectedApplicants) =>
        prevSelectedApplicants.filter((id) => id !== itemId)
      );
    } else {
      setSelected((prevSelectedApplicants) => [
        ...prevSelectedApplicants,
        itemId,
      ]);
    }
  };
  useEffect(() => {
    return setSelected([]);
  }, []);

  useEffect(() => {
    refetchUsers();
  }, [order]);

  const handleSelectAll = () => {
    let array = [];
    data?.items?.map((item) => array.push(item.userId));

    if (selected.length) {
      setSelected([]);
    } else {
      setSelected(array);
    }
  };

  const handleOrder = (column) => {
    // const keys = Object.keys(data?.items[0]);

    if (order[1] === 'asc') {
      setOrder([column, 'desc']);
    } else {
      setOrder([column, 'asc']);
    }
  };

  useEffect(() => {
    setSelectedUser([...selected]);
  }, [selected]);

  if (isUsersLoading) {
    return <Loader />;
  }

  const handleRolesDisplay = (item) => {
    if (item.userRoles) {
      const rolesArray = item.userRoles?.split(',');
      const rolesCount = rolesArray?.length;

      if (rolesCount === 0) {
        return '';
      } else if (rolesCount === pagesDataCount) {
        return 'All';
      } else if (rolesCount === 1) {
        return rolesArray[0];
      } else {
        return rolesArray[0] + ', +' + (rolesCount - 1);
      }
    }
  };

  return (
    <>
      <div className={styles['container']}>
        <table className={styles['userstable-container']}>
          <thead>
            <tr>
              <th
                className={`${styles.firstRadius}`}
                style={{ position: 'relative' }}
              >
                <img
                  className={styles['checkedIcon']}
                  src={checkedicon}
                  alt=""
                  onClick={() => handleSelectAll()}
                />
              </th>

              {tableHeader &&
                tableHeader?.map((item, index) => {
                  return (
                    <th className={`${styles['header-cell']} `} key={index}>
                      {item.name}{' '}
                      {order[1] === 'asc' && order[0] === item.originalName ? (
                        <img
                          className={styles['pointer']}
                          src={upArrow}
                          alt="icon"
                          onClick={() => handleOrder(item.originalName)}
                        />
                      ) : (
                        <img
                          className={styles['pointer']}
                          src={downArrow}
                          alt="icon"
                          onClick={() => handleOrder(item.originalName)}
                        />
                      )}
                    </th>
                  );
                })}
              <th className={`${styles.lastRadius}`}></th>
            </tr>
          </thead>
          <tbody>
            {data?.items?.map((item) => (
              <tr
                key={item.userId}
                onClick={() => {
                  setViewModal(item.userId);
                  setEachUser(item);
                }}
                style={{ position: 'relative' }}
              >
                <td
                  onClick={(e) => handleCheckboxClick(e, item.userId)}
                  className={styles['tr-checkbox']}
                >
                  <CheckBox
                    value={selected?.includes(item.userId)}
                    onChange={() => toggleCheckUser(item.userId)}
                  />
                  <div
                    className={
                      selected?.includes(item.userId)
                        ? styles['leftBorder']
                        : ''
                    }
                  >
                    <p></p>
                  </div>
                </td>
                <td>{item.fullName_En}</td>
                <td>{item.fullName_AR}</td>
                <td>{item.email}</td>
                <td>{item.mobile}</td>
                <td title={item.userRoles}>
                  {item.userRoles &&
                  item.userRoles.split(',')?.length === pagesDataCount
                    ? 'All'
                    : item.userRoles && item.userRoles.split(',').length === 0
                    ? 'No Page Assign'
                    : item?.userRoles?.length > 40
                    ? item?.userRoles?.substring(0, 40) + ' ...'
                    : item?.userRoles}
                </td>
                <td
                  className={`${styles.lastRadius}`}
                  style={{ overflow: 'visible' }}
                >
                  <MoreButton
                    icon={moreInfo}
                    setShowStatus={setShowStatus}
                    width={'249px'}
                    left="0"
                  >
                    <PopOver
                      info={[
                        {
                          title: 'تعديل',
                          icon: editIcon,
                          handleFunction: (e) => {
                            e.stopPropagation();
                            setIsModalOpen(true);
                            setModalMode('Edit');
                            setEachUser(item);
                          },
                        },
                        {
                          title: 'إعادة تعيين الصفحة',
                          icon: assignIcon,
                          handleFunction: (e) => {
                            e.stopPropagation();
                            setAssignRole(true);
                            setModalMode('Edit');
                            setEachUser(item);
                          },
                        },
                        {
                          title: 'إعادة تعيين كلمة المرور',
                          icon: ProfilePsswordIcon,
                          handleFunction: (e) => {
                            e.stopPropagation();
                            setResetPasword(true);
                            setEachUser(item);
                          },
                        },
                        {
                          title: 'حذف',
                          icon: deleteIcon,
                          handleFunction: (e) => {
                            e.stopPropagation();
                            setDeleteMode(true);
                            setSelectedUser([item.userId]);
                          },
                        },
                      ]}
                    />
                  </MoreButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TablePagination
        totalPages={totalPages}
        page={page}
        setPage={setPage}
        itemsPerPage={pageSize}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default UsersTable;
